import styled, { css } from 'styled-components';
import { rgba } from 'polished';

export const Wrapper = styled.footer`
  ${({ theme }) => css`
    background-color: ${theme.colors.neutralSilver100};
    padding: 30px 24px;
    display: flex;
    justify-content: center;

    @media (max-width: 992px) {
      padding: 32px 24px;
    }
  `}
`;

export const Container = styled.div`
  max-width: 1320px;
  width: 100%;
`;

export const LinksRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 48px;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
  }
`;

export const LogoSection = styled.div`
  display: flex;
  flex-direction: column;

  img {
    max-width: 180px;
  }

  @media (max-width: 992px) {
    align-items: center;
    margin-bottom: 32px;
  }
`;

export const LogoText = styled.span`
  ${({ theme }) => css`
    font-size: 1.4rem;
    color: ${theme.colors.neutralGray40};
  `}
`;

export const SocialSection = styled.div`
  ${({ theme }) => css`
    a {
      color: ${theme.colors.neutralSilver10};
      text-decoration: none;

      &:not(:last-child) {
        margin-right: 32px;
      }

      &:hover {
        color: ${rgba(theme.colors.neutralSilver10, 0.8)};
      }
    }
  `}
`;

export const CopySection = styled.div`
  ${({ theme }) => css`
    border-top: 1px solid ${rgba(theme.colors.neutralSilver90, 0.6)};
    border-bottom: 1px solid ${rgba(theme.colors.neutralSilver90, 0.6)};
    padding: 32px 24px;

    @media (max-width: 992px) {
      border-bottom: none;
      padding: 32px 24px 0 24px;
    }
  `}
`;

export const CopyText = styled.span`
  ${({ theme }) => css`
    font-size: 1.6rem;
    font-weight: 600;
    color: ${theme.colors.globalWhite100};
    text-align: center;
    margin: 0;
    display: block;
  `}
`;
